import React from 'react';
import { Calendar, Play } from 'lucide-react';
import './LaunchAnnouncement.css';

const LaunchAnnouncement = () => {
  return (
    <section className="launch-announcement">
      <div className="launch-announcement__container">
        <div className="launch-announcement__content">
          {/* Logo Section */}
          <div className="launch-announcement__logo-wrapper">
            <img src="/gwjwr-logo.png" alt="GWJWR Logo" className="launch-announcement__logo" />
          </div>

          {/* Brand Name */}
          <div className="launch-announcement__brand">
            <h1 className="launch-announcement__brand-name">GWJWR</h1>
            <div className="launch-announcement__brand-tagline">
              <Play size={20} />
              <span>Premium OTT Platform</span>
            </div>
          </div>

          {/* Launch Date Section */}
          <div className="launch-announcement__launch-date">
            <div className="launch-announcement__calendar-icon">
              <Calendar size={28} />
            </div>
            <div className="launch-announcement__date-info">
              <span className="launch-announcement__date-label">Coming Soon</span>
              <span className="launch-announcement__date-text">Launching on 2 November</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default LaunchAnnouncement
